export const isOpen = ({ modal }) => !!modal?.props
export const isForm = ({ modal }) =>
  !!modal?.props?.app && !!modal?.props?.model
export const isMessaging = ({ modal }) => !!modal?.props?.messaging
export const data = ({ modal }) => modal?.props || {}
export const state = ({ modal }) => modal?.props?.__state || {}
export const values = (state) => data(state)?.values || {}
